import { useCallback, useEffect, useState } from "react";
import {
  DEFAULT_SWIPE_STACK_TUNING,
  loadSwipeStackTuning,
  type SwipeStackTuning,
  saveSwipeStackTuning,
} from "./swipeStackTuning";

export function useSwipeStackTuning() {
  const [tuning, setTuningState] = useState<SwipeStackTuning>(loadSwipeStackTuning);

  useEffect(() => {
    saveSwipeStackTuning(tuning);
  }, [tuning]);

  const setTuning = useCallback((patch: Partial<SwipeStackTuning>) => {
    setTuningState((prev) => ({ ...prev, ...patch }));
  }, []);

  const resetTuning = useCallback(() => {
    setTuningState(DEFAULT_SWIPE_STACK_TUNING);
  }, []);

  return { tuning, setTuning, resetTuning };
}
